import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    title: '第1条（適用）',
    content: `本利用規約（以下「本規約」）は、Dr.Catch（以下「当サービス」）が提供するカウンセリングサービスの利用に関する条件を定めるものです。ご利用の前に必ずお読みいただき、同意の上でご利用ください。`,
  },
  {
    title: '第2条（サービスの内容）',
    content: `当サービスは、カウンセラー・ジェイゾロフト瞳によるオンラインカウンセリングセッションを提供します。セッションはビデオ通話またはチャット形式で行われます。`,
  },
  {
    title: '第3条（利用登録）',
    content: `本サービスのご利用には、予約フォームへの必要事項の入力が必要です。虚偽の情報を登録した場合、当サービスはご利用をお断りする場合があります。`,
  },
  {
    title: '第4条（料金・支払い）',
    content: `各セッションの料金は、予約ページに記載の金額とします。料金は事前にお支払いいただきます。支払い方法については予約ページをご確認ください。`,
  },
  {
    title: '第5条（キャンセル・変更）',
    content: `セッションのキャンセル・変更は、セッション開始の24時間前までにご連絡ください。\n・24時間以上前のキャンセル：全額返金\n・24時間以内のキャンセル：返金不可\n・無断キャンセル：返金不可`,
  },
  {
    title: '第6条（禁止事項）',
    content: `利用者は以下の行為を行ってはなりません。\n・法令または公序良俗に違反する行為\n・セッション内容の無断録音・録画・転載\n・カウンセラーへの誹謗中傷・ハラスメント行為\n・その他、当サービスが不適切と判断する行為`,
  },
  {
    title: '第7条（免責事項）',
    content: `当サービスは医療行為を提供するものではありません。精神科・心療内科等の医療機関への受診が必要な場合は、適切な医療機関をご案内します。当サービスの利用により生じた損害について、当サービスは責任を負いかねます。`,
  },
  {
    title: '第8条（規約の変更）',
    content: `当サービスは、必要に応じて本規約を変更することがあります。変更後の規約は、本ページに掲載した時点から効力を生じるものとします。`,
  },
  {
    title: '第9条（準拠法・管轄）',
    content: `本規約は日本法に準拠し、本サービスに関する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。`,
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />

      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-14">
            <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-3">Terms of Service</p>
            <h1 className="text-3xl md:text-4xl font-serif mb-4 text-[#2C2C2C]">利用規約</h1>
            <div className="w-24 h-px bg-[#D4A5A5] mx-auto mb-4"></div>
            <p className="text-sm text-[#888888]">最終更新日：2025年1月1日</p>
          </div>

          {/* Intro */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#F5E8E4] mb-8">
            <p className="text-base leading-loose text-[#4A4A4A]">
              本規約は、Dr.Catchが提供するカウンセリングサービスをご利用いただく際の条件を定めたものです。サービスをご利用いただくことで、本規約に同意いただいたものとみなします。
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-6">
            {sections.map((section) => (
              <div
                key={section.title}
                className="bg-white rounded-2xl p-8 shadow-sm border border-[#F5E8E4]"
              >
                <h2 className="text-base font-semibold text-[#2C2C2C] mb-4 flex items-center gap-3">
                  <span className="w-1.5 h-5 bg-[#D4A5A5] rounded-full inline-block flex-shrink-0"></span>
                  {section.title}
                </h2>
                <p className="text-sm leading-loose text-[#4A4A4A] whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div className="text-center mt-14">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#C9A0A0] hover:text-[#B88B8B] transition-colors text-sm cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              トップページに戻る
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
